import React, { useState, useContext, Suspense, lazy } from "react";
import { useSearchParams } from "react-router-dom";
import { TableContext } from "../../context";
import { McTabBar } from "@maersk-global/mds-react-wrapper/components-core/mc-tab-bar";
import { McTab } from "@maersk-global/mds-react-wrapper/components-core/mc-tab";
import Loader from "../Loader";
import "./Dashboards.css";

const RedGreenChannelTracker = lazy(() => import("../RedGreenChannelTracker"));
const P1P2Incidents = lazy(() => import("../P1P2Incidents"));
const ErrorBudget = lazy(() => import("../ErrorBudget"));

const TAB_KEYS = ["RedGreenChannel", "P1P2Incidents", "ErrorBudget"];
const TAB_LABELS = ["Red/Green Channel", "P1/P2 Incidents", "Error Budget"];

export default function Dashboards() {
  const { userRole } = useContext(TableContext);
  const [searchParams, setSearchParams] = useSearchParams();

  const initialTab = searchParams.get("tab") || TAB_KEYS[0];
  const initialIndex = TAB_KEYS.indexOf(initialTab);
  const [activeIndex, setActiveIndex] = useState(initialIndex >= 0 ? initialIndex : 0);

  if (userRole === null) {
    return <Loader />;
  }

  const handleTabChange = (e) => {
    const idx = e.detail;
    setActiveIndex(idx);
    setSearchParams({ tab: TAB_KEYS[idx] });
  };

  const isAdminOrCM = userRole === "admin" || userRole === "change manager";

  const renderActivePanel = () => {
    let panel;
    switch (activeIndex) {
      case 0:
        panel = <RedGreenChannelTracker />;
        break;
      case 1:
        if (!isAdminOrCM) {
          return (
            <div style={{ textAlign: "center", marginTop: "50px" }}>
              Unauthorized Access
            </div>
          );
        }
        panel = <P1P2Incidents />;
        break;
      case 2:
        panel = <ErrorBudget />;
        break;
      default:
        panel = <RedGreenChannelTracker />;
    }
    return <Suspense fallback={<Loader />}>{panel}</Suspense>;
  };

  return (
    <div className="dashboards-container">
      <div className="dashboards-tab-bar">
        <McTabBar tabchange={handleTabChange} currentindex={activeIndex}>
          <McTab slot="tab" label="Red/Green Channel" />
          <div slot="panel" />
          <McTab slot="tab" label="P1/P2 Incidents" />
          <div slot="panel" />
          <McTab slot="tab" label="Error Budget" />
          <div slot="panel" />
        </McTabBar>
      </div>
      <div className="dashboards-content">
        {renderActivePanel()}
      </div>
    </div>
  );
}
